import axios from "axios";

export const fetchTable = async (wardId, year) => {
    try {
        const result = await axios.get(`/admin/request/no-annual-leave?wardId=${wardId}&year=${year}`);
        return result;
    } catch (error) {
        console.error(error);
    }
};

export const postLeave = async (scheduleId, leave) => {
    try {
        const params = {
            userId: leave.userId,
            annualWeekId: leave.weekId,
            value: leave.value,
        };
        const result = await axios.put(`/admin/request/no-annual-leave/${scheduleId}`, params);
        return result;
    } catch (error) {
        console.error(error);
    }
};

export const shiftUser = async (scheduleId, userIdList) => {
    try {
        const params = {
            list: userIdList,
        };
        const result = await axios.put(`/admin/request/no-annual-leave/shift/${scheduleId}`, params);
        return result;
    } catch (error) {
        console.error(error);
    }
};

export const fetchYearSettings = async scheduleId => {
    try {
        const result = await axios.get(`/admin/request/no-annual-leave/settings/year/${scheduleId}`);
        return result;
    } catch (error) {
        console.error(error);
    }
};

export const putCutOffDate = async (scheduleId, cutOffDate) => {
    try {
        const params = {
            cutOffDate: cutOffDate,
        };
        const result = await axios.put(`/admin/request/no-annual-leave/settings/year/${scheduleId}`, params);
        return result;
    } catch (error) {
        console.error(error);
    }
};

export const putShowSchedule = async (scheduleId, show) => {
    try {
        const params = {
            show: show,
        };
        const result = await axios.put(`/admin/request/no-annual-leave/settings/year/${scheduleId}`, params);
        return result;
    } catch (error) {
        console.error(error);
    }
};

export const fetchWeekSettings = async scheduleId => {
    try {
        const result = await axios.get(`/admin/request/no-annual-leave/settings/week/${scheduleId}`);
        return result;
    } catch (error) {
        console.error(error);
    }
};

export const putWeekSettings = async week => {
    try {
        const params = {
            tag: week.tag,
            limit: week.vacancy,
        };
        const result = await axios.put(`/admin/request/no-annual-leave/settings/week/${week.id}`, params);
        return result;
    } catch (error) {
        console.error(error);
    }
};

export const fetchUserSettings = async weekId => {
    try {
        const result = await axios.get(`/admin/request/no-annual-leave/settings/week/block/${weekId}`);
        return result;
    } catch (error) {
        console.error(error);
    }
};

export const putUserSettings = async (weekId, users) => {
    try {
        const result = await axios.put(`/admin/request/no-annual-leave/settings/week/block/${weekId}`, users);
        return result;
    } catch (error) {
        console.error(error);
    }
};

export const putAllVacancy = async (scheduleId, vacancy) => {
    try {
        const params = {
            limit: vacancy,
        };
        const result = await axios.put(`/admin/request/no-annual-leave/settings/week/all/${scheduleId}`, params);
        return result;
    } catch (error) {
        console.error(error);
    }
};

export const fetchRanking = async scheduleId => {
    try {
        const result = await axios.get(`/admin/request/no-annual-leave/rank/${scheduleId}`);
        return result;
    } catch (error) {
        console.error(error);
    }
};

export const fetchOptions = async () => {
    try {
        return [
            { id: 1, name: "", value: "" },
            { id: 2, name: "ML", value: "ML" },
            { id: 3, name: "AL", value: "AL" },
            { id: 4, name: "NPL", value: "NPL" },
            { id: 5, name: "#", value: "#" },
            { id: 5, name: "@", value: "@" },
        ];
    } catch (error) {
        console.error(error);
    }
};

export const fetchModal = async wardId => {
    try {
        const result = await axios.get(`/admin/request/no-annual-leave/settings/ward/${wardId}`);
        return result;
    } catch (error) {
        console.error(error);
    }
};

export const postModal = async (wardId, msg) => {
    try {
        const params = {
            modalMessage: msg ? msg : "",
        };
        const result = await axios.put(`/admin/request/no-annual-leave/settings/ward/${wardId}`, params);
        return result;
    } catch (error) {
        console.error(error);
    }
};

export const addNewSchedule = async wardId => {
    try {
        const result = await axios.post(`/admin/request/no-annual-leave?wardId=${wardId}`);
        return result;
    } catch (error) {
        console.error(error);
    }
};

export const passUser = async scheduleId => {
    try {
        const result = await axios.post(`/admin/request/no-annual-leave/pass/${scheduleId}`);
        return result;
    } catch (error) {
        console.error(error);
    }
};

export const nextRound = async scheduleId => {
    try {
        const result = await axios.post(`/admin/request/no-annual-leave/next-round/${scheduleId}`);
        return result;
    } catch (error) {
        console.error(error);
    }
};

// modal settings
// export const fetchModal = async (scheduleId) => {
// 	try {
// 		const result = await axios.get(
// 			`/admin/request/no-annual-leave/setting/${scheduleId}`
// 		);
// 		return result;
// 	} catch (error) {
// 		console.error(error);
// 	}
// };

// export const postModal = async (scheduleId, msg) => {
// 	try {
// 		const params = {
// 			modalMessage: msg,
// 		};
// 		const result = await axios.put(
// 			`/admin/request/no-annual-leave/setting/${scheduleId}`,
// 			params
// 		);
// 		return result;
// 	} catch (error) {
// 		console.error(error);
// 	}
// };
